import config from "projectRoot/config.json";
import Request from "./request";
import { findPath } from "./tools";

export default function getCodeMap(code) {
  return Request.GET(`${config.host}/dict/item/list/${code}`, {
    params: { current: 1, pageSize: 100 },
  }).then((res) => {
    if (
      code === "ORDER_STATUS" &&
      res.data &&
      Array.isArray(res.data.records)
    ) {
      const arr = res.data.records.filter((item) => {
        if (item.value === "20") {
          item.name = "待核销";
        }
        if (item.value === "40") {
          item.name = "待顾客签字";
        }
        return true;
      });
      res.data.records = arr;
      return res;
    }
    return res;
  });
}

export const listByCode = (code) =>
  Request.GET(`${config.host}/dict/item/listByCode/${code}`).then(
    ({ data }) => {
      if (code === "ORDER_STATUS" && Array.isArray(data)) {
        data = data.filter((item) => {
          if (item.value === "20") {
            item.name = "待核销";
          }
          if (item.value === "40") {
            item.name = "待顾客签字";
          }
          return true;
        });
        return data;
      }
      return Array.isArray(data) ? data : [];
    }
  );

export function findNameByCode(code, codeMap, ck, vk) {
  let ret = "";
  if (vk) {
    codeMap.some((item) => {
      if (item[ck] === code) {
        ret = item[vk];
        return true;
      }
      return false;
    });
  } else {
    codeMap.some((item) => {
      // if (item.code === "ORDER_STATUS" && code === "50") {
      //   ret = "已完成";
      //   return true;
      // }
      if (item.value === code) {
        ret = item.name;
        return true;
      }
      return false;
    });
  }

  return ret;
}
export function findAreaByCityCode(code, func) {
  import("../../public/asset/json/city_tree.json").then((res) => {
    findPath(res, "value", code, (ret) => {
      if (ret) {
        func(ret.map((item) => item.label).join("/"));
      } else {
        func(undefined);
      }
    });
  });
}
/**
 * 已知地址列表 快速查询地址信息
 * @param {string} code
 * @param {function} func
 * @param {object} res
 */
export function fabcc(code, area, func) {
  findPath(area, "value", code, (ret) => {
    if (ret) {
      func(ret.map((item) => item.label).join("/"));
    } else {
      func(undefined);
    }
  });
}



// WEBPACK FOOTER //
// ./src/util/codeMap.js